import type { SetInPointForSourceAction } from '../timelineActions';
import type { TimelineInternalOps } from '../../timelineInternalOps';


export function setInPointForSource(timelineInternalHelper: TimelineInternalOps, action: SetInPointForSourceAction) {
  action.undo = timelineInternalHelper.setInPointOfTrackBoxGroup(action.sourceId, action.newInPointInSeconds, action.sourcesDelta);
}

